import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { adaptApiError } from '@hglobal/fin-ui';
import { Observable } from 'rxjs';

import { AuthApi } from './auth-api.interface';
import { buildAuthApiUrl } from '../helpers';

@Injectable()
export class AuthApiService implements AuthApi {
  readonly #http = inject(HttpClient);

  logout(): Observable<void> {
    return this.#http.post<void>(buildAuthApiUrl('logout'), {}).pipe(adaptApiError());
  }
}
